/**
 * Ícone de cada módulo: o seletor do cabeçalho e as marcações que remetem
 * ao módulo em outras telas usam o mesmo, para o usuário reconhecer de onde vem.
 */
export const ICONE_MODULO = {
  BAS: "heroicons_outline:home",
  EST: "heroicons_outline:archive-box",
  ALU: "heroicons_outline:truck",
} as const;
